import NotFoundPage from '@/pages/404';
import ErrorBoundary from '@/pages/ErrorBoundary';
import { routeTree } from '@/routeTree.gen';
import { environmentManager, QueryCache, QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';

const getQueryClient = () => {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (environmentManager.isServer()) {
          const span = (global as any)._datadog_tracer?.scope().active();
          if (span) {
            span.setTag('error', error);
          }
        }
      },
    }),
  });
};

export const getRouter = () => {
  const queryClient = getQueryClient();

  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    context: { queryClient },
    defaultPreload: 'intent',
    defaultErrorComponent: ErrorBoundary,
    defaultNotFoundComponent: NotFoundPage,
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  });

  return router;
};

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
